<template>
  <div
    class="login-boxs size_no_repeat vue_flex vue_flex_end"
    :style="{ width: innerWidth + 'px', height: innerHeight + 'px' }"
  >
    <div class="login-boxs-right vue_flex vue_column vue_relative">
      <img
        src="../../assets/yimou/logo.png"
        class="login-boxs-right-logo vue_absolute"
      />
      <ul
        class="login-boxs-right-view vue_flex vue_column"
        style="width: 473px"
      >
        <li class="login-boxs-right-view-title vue-font-PingFang-bold">
          欢迎使用
        </li>

        <li class="login-boxs-right-view-input vue_flex vue_align_center">
          <img src="../../assets/yimou/ic_gs.png" alt="" />
          <el-input
            v-model="tempObj.account"
            placeholder="请输入账号"
          ></el-input>
        </li>

        <li class="login-boxs-right-view-input vue_flex vue_align_center">
          <img src="../../assets/yimou/ic_gs.png" alt="" />
          <el-input
            v-model="tempObj.password"
            placeholder="请输入密码"
            show-password
          ></el-input>
        </li>

        <li
          class="login-boxs-right-view-but vue-font-PingFang-500"
          @click="loginClick"
        >
          进入
        </li>
        <li class="login-boxs-right-view-contact vue_flex vue_flex_around">
          <div class="vue_flex">
            <p class="vue-font-PingFang-500">遇到问题?</p>
            <p class="vue-font-PingFang-500">联系我们</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import jsmd5 from "js-md5";
import { windowFun } from "@/utils/utils";
import DonMessage from "@/utils/message";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      innerWidth: 0,
      innerHeight: 0,
      tempObj: {
        account: "",
        password: "",
      },
    };
  },

  created() {
    this.innerWidth = windowFun().innerWidth;
    this.innerHeight = windowFun().innerHeight;
    if (Cookies.get("QYS-JWT")) {
      if (Cookies.get("QYS-uid") && Cookies.get("userCompany")) {
        this.$router.push({ path: `/main` });
      }
      if (Cookies.get("QYS-uid") && !Cookies.get("userCompany")) {
        this.$router.push({ path: `/company` });
      }
    }
  },

  methods: {
    async loginClick() {
      if (!this.tempObj.account) return DonMessage.error(`请输入账号`);
      if (!this.tempObj.password) return DonMessage.error(`请输入密码`);

      const res = await this.$http.get(this.$urls.login, this.tempObj);
      if (res.errcode === 1){
        Cookies.remove('QYS-JWT');
        Cookies.remove('userObj');
        DonMessage.error(res.errmsg)
        return
      }
      if (res.errcode != 0) return DonMessage.error(res.errmsg);

      Cookies.set("QYS-JWT", res.data.jwt);
      Cookies.set("ymuser", JSON.stringify(res.data.user));
      Cookies.set("ymversion", JSON.stringify(res.data.version));
      console.log('res.data',res.data);
      res.data.user.uid = res.data.user.id;
      this.$nextTick(() =>{
        this.getRoleByCompanyFun(res.data.user)
      })
      // return;
      // this.$router.push({ path: "/main/level1/dashboardcompre" });
    },
    // 获取权限
    async getRoleByCompanyFun(data){
      const response = await this.$http.get(this.$urls.getMenuByroles)
      console.log(response, '根据公司id获取路由')
      if(Number(response.errcode) === 0){
        localStorage.setItem('Menuroute', JSON.stringify(response.data.menu));
        this.$router.push({ path: "/main/level1/dashboardcompre" });
      } else {
        DonMessage.error(response.errmsg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.login-boxs {
  background-image: url("../../assets/yimou/ic_dl_bg.png");
  .login-boxs-right {
    height: 100%;
    padding-top: 45px;
    padding-right: 203px;
    .login-boxs-right-logo {
      width: 206px;
      height: 55px;
      left: -136px;
    }
    .login-boxs-right-view {
      margin-top: 163px;
      .login-boxs-right-view-title {
        font-size: 40px;
        color: rgba(35, 35, 35, 1);
        line-height: 40px;
        margin-bottom: 60px;
      }
      .login-boxs-right-view-input {
        margin-bottom: 38px;
        padding: 26px 35px;
        background: rgba(245, 249, 252, 1);
        border-radius: 9px;
        img {
          width: 40px;
          height: 40px;
          margin-right: 16px;
        }
      }

      .login-boxs-right-view-but {
        width: 473px;
        height: 73px;
        line-height: 73px;
        text-align: center;
        background: rgba(25, 92, 248, 1);
        border-radius: 10px;
        font-size: 22px;
        color: rgba(255, 255, 255, 1);
        margin: 57px 0px 26px;
      }
      .login-boxs-right-view-contact {
        p {
          font-size: 18px;
          color: rgba(35, 35, 35, 1);
          line-height: 18px;
        }
        p:nth-of-type(2) {
          color: rgba(25, 92, 248, 1);
        }
      }
    }
  }
}

.el-input /deep/.el-input__inner {
  border: none !important;
  background: none !important;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue